export function clamp(n: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, n));
}

export function formatCount(n: number, locale?: string): string {
    try {
        return new Intl.NumberFormat(locale).format(n);
    } catch {
        return String(n);
    }
}

export function formatPercent(value: number, locale?: string, digits = 1): string {
    const clamped = clamp(value, 0, 1);
    try {
        return new Intl.NumberFormat(locale, {
            style: "percent",
            maximumFractionDigits: digits,
            minimumFractionDigits: digits,
        }).format(clamped);
    } catch {
        return `${(clamped * 100).toFixed(digits)}%`;
    }
}

export function formatShortDay(iso: string, locale?: string): string {
    const d = new Date(iso);
    try {
        const out = new Intl.DateTimeFormat(locale, {
            day: "2-digit",
            month: "short",
        }).format(d);
        return out.replace(".", "");
    } catch {
        return d.toLocaleDateString(undefined, {
            month: "short",
            day: "2-digit",
        });
    }
}

export function formatDateTime(ts: number) {
    try {
        return new Intl.DateTimeFormat(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
        }).format(new Date(ts));
    } catch {
        return new Date(ts).toLocaleString();
    }
}

export function formatMoney(cents: number, currency: string, locale?: string): string {
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: (currency || "eur").toUpperCase(),
        }).format(cents / 100);
    } catch {
        return `${(cents / 100).toFixed(2)} ${currency}`;
    }
}

export function formatDay(ts: number, locale?: string): string {
    try {
        return new Intl.DateTimeFormat(locale, {
            day: "numeric",
            month: "short",
            year: "numeric",
        }).format(new Date(ts));
    } catch {
        return new Date(ts).toLocaleDateString();
    }
}
